import React from "react";
import { faSparkles, faSquirrel } from "@fortawesome/pro-regular-svg-icons";
import { Flex } from "@singlestore/fusion/components/layout";
import { useFlyout } from "contexts/FlyoutContext";

import { Button } from "components/Button/Button";
import { FaIcon } from "components/FaIcon/FaIcon";
import { Paragraph } from "components/Paragraph/Paragraph";

import { track } from "utils/segment";

import "./SqrlCallout.scss";

export function SqrlCallout() {
    const { setTab } = useFlyout();

    const handleClick = () => {
        setTab("sqrl");
        track("SQrL Conversation Initiated", {
            method: "Homepage Callout",
        });
    };

    return (
        <Flex
            className="sqrl-callout"
            justifyContent="space-between"
            p="2x"
            gap="2x"
        >
            <Flex alignItems="center" gap="2x">
                <Flex
                    className="sqrl-icon"
                    width="5x"
                    height="5x"
                    justifyContent="center"
                    alignItems="center"
                    flexShrink="0"
                >
                    <FaIcon icon={faSquirrel} />
                </Flex>
                <Paragraph variant="heading-2">
                    Ask SQrL, our AI assistant, trained on all things
                    SingleStore
                </Paragraph>
            </Flex>

            <Button
                iconLeft={<FaIcon icon={faSparkles} />}
                variation="solid-brand"
                onClick={handleClick}
            >
                Ask SQrL
            </Button>
        </Flex>
    );
}
